import React from "react";
const InventoryPage = (props) => {
    return (React.createElement("div", null));
};
export default InventoryPage;
